var base = require("./home");
import Axios from "axios";

import upload from "./new-task/upload.vue";
import draw from "./new-task/draw.vue";
import imageselect from "./new-task/imageselect.vue";
import crop from "./new-task/crop.vue";
import startingpoints from "./new-task/startingpoints.vue";
import parameters from "./new-task/parameters.vue";
import rawdata from "./new-task/rawdata.vue";
import postprocessing from "./new-task/postprocessing.vue";
import dataoutput from "./new-task/dataoutput.vue";
import savelinelength from "./new-task/savelinelength.vue";
import presets from "./new-task/presets.vue";
import { Form, HasError, AlertError } from "vform";
import VueJsonPretty from "vue-json-pretty";
import modal from "../components/modal.vue";
import "vue-json-pretty/lib/styles.css";
import { lowerCase } from "lodash";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import "vue-nav-tabs/themes/vue-tabs.css";



// add stylesheet
require("vue-select-image/dist/vue-select-image.css");

Vue.component("new-task", {
    props: ["user"],
    components: {
        upload: upload,
        draw: draw,
        imageselect: imageselect,
        crop: crop,
        startingpoints: startingpoints,
        parameters: parameters,
        presets: presets,
        Axios,
        VueJsonPretty,
        modal,
        VueTabs,
        VTab,
        postprocessing: postprocessing,
        dataoutput: dataoutput,
        rawdata: rawdata,
        savelinelength: savelinelength
    },
    data: function() {
        return {
            debug : false,
            nowStep: 1,
            showModalSP: false,
            showModalCP: false,
            stepList: [
                "Upload images",
                "Select reference",
                "Crop",
                "Startingpoints",
                "parameters"
            ],
            form: new Form({

                //Section Upload
                refimage: {},
                fileIds: [],
                files: [],

                //section image settings
                startingpoints: [],
                crop: "",

                //section presets 
                name: "",
                fiber_diameter_value: 1,
                chooseUnit: "px",
                fiber_diameter_unit: "unit",
                preset: "default",
                set_scale: false,
                set_scale_value: 1000, //0-9999999
                set_scale_px: 1, // nummer mit + px ergänzen
                
                //section advanced parameters
                advanced: false,
                sigma_smooth: 0.5, // >0
                sigma_conv: 0.45, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                r_min: 0, // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                r_max: 2, // > r_min // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                steps: 360, // >0 INTEGER
                thresh: 2, // beliebig
                r_step: 0.75, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                min_loop_length: 7, // > 1 INTEGER
                auto_startpoint: true, // WENN auto_startpoint = yes dann drei Parameter
                use_modified_hessian: true, //true/false
                delete_worst_sections: true, 
                delete_worst_sections_value: 0, //default: 2* sigma_conv // >=0
                no_rescaling: false, //checkbox value='rescaling' wenn checkbox resacaling dektiviert ist, gebe no_resacling mit den params


                //dataoutput
                save_loop_area:false,
                save_loop_area_value: 0,
                save_all_junction_distances: false,
                save_all_junction_distances_value: null,
                save_loop_junction_distances: false,
                save_loop_junction_distances_value: 0,
                save_loop_circleness: false,
                save_all_absolute_angles: false,
                save_auxiliary_data: false,
                save_loop_circumferences: false, 
                saves: [], // save loop length

                //section preprocessing
                delete_nodes_above_threshold_check: false, //yes/no
                delete_nodes_above_threshold: 0, //0-255
                delete_nodes_below_threshold_check: false, //yes/no
                delete_nodes_below_threshold: 0, //0-255
                delete_lines_above_threshold_check: false, //yes/no
                delete_lines_above_threshold: 0, //0-255
                delete_lines_below_threshold_check: false, //yes/no
                delete_lines_below_threshold: 0, //0-255
                
                
                //section draw
                draws: [{name: "result",fiber_network: true, background: "original", network_color_type: "rgb", network_thickness: 1, network_color_rgb:"#C0382B", loops:false, loops_color_type:"rgb", loops_thickness: 1}],
                animate_tracing: false, //Nur ein mal /
                animate_color_type: "rgb",
                animate_color_rgb: "rgb(51, 152, 219)", //ausgrauen wenn oben angle_hue ausgewählt wird
                animate_thickness: "1", // 1-1000
                
                //section raw data
                save_tracing_data: false, // nur einmal dateiname
                save_loop_data: false, //Nur ein mal aufrufen /dateiname eingeben
            }),
            isMounted: false,
            showSpinner: false,
            showImageseletor: false,
            showFiberdiameter: false,
            balance: 0,
            allowed: false,
            
        };
    },
    created() {
        var self = this;
    },
    mounted(){

        this.isMounted=true;
        this.getBalance()
    },
    computed: {
        refLen() {
            if (Object.keys(this.form.refimage).length) {
                return true;
            } else {
                return false;
            }
        },
        fileLen() {
            return this.form.files.length;
        },
        crop() {
            return this.$refs.crop;
        }
    },
    watch: {
        fileLen() {
            if (this.fileLen == 0) {
                this.showImageseletor = false;
                console.log("I1");
            }
            if (this.fileLen == 1) {
                this.showImageseletor = false;
                this.form.refimage = this.form.files[0];
                if(this.isMounted){
                    this.$refs.crop.loadCb();
                }
            } else {
                this.showImageseletor = true;
                console.log("I1");
            }
        },
        diameterPx() {
            $unit = lowerCase(this.form.fiber_diameter_unit);
            if ($unit == "px" || $unit == "pixel" || $unit == "pixels") {
                return true;
            }
            return false;
        }
    },
    methods: {
        getBalance(){
            axios.get("/team", {}).then(response => {
                console.log((response.data));
                this.team = response.data.current_team;
                this.balance = response.data.balance;
                if(this.balance > 0)
                    this.allowed = true;
            });
        },
        updateRefimage(image) {
            this.form.refimage = image;
            this.$refs.crop.loadCb();

        },
        /*async next() {

                if (this.form.files.length == 1) {
                    this.form.refimage = this.form.files[0];
                    this.nowStep = 3;
                }
                if (this.form.files.length > 1) {
                    this.nowStep = 2;
                }




        }, */
        back() {
            this.nowStep = this.nowStep - 1;
        },
        copyObject(obj) {
            var cp = {};
            for (var o in obj) {
                cp[o] = obj[o];
            }
            return cp;
        },
        submit() {
            //console.log("adv: " + this.form.advanced);

            //console.log(JSON.stringify(this.basic_parameters));
            this.showSpinner = true;
            this.form.refimage.src = null;
            //this.form.files = null;
            axios
                .post("/task", this.form)
                .then(response => {
                    window.location = "/home/dashboard";
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.form.errors = error.response.data.errors;
                    }
                });
            this.showSpinner = false;
        }
    }
});
